import { Instagram, Youtube, Mail, ArrowUpRight, ArrowLeft } from "lucide-react";
import { LINKS } from "../../lib/links";

const SOCIAL = [
  { icon: Instagram, label: "Instagram", href: LINKS.instagram, id: "instagram" },
  { icon: Youtube, label: "YouTube", href: LINKS.youtube, id: "youtube" },
  { icon: Mail, label: "Email", href: LINKS.email, id: "email" },
];

export const BuildDayFooter = () => {
  return (
    <footer
      data-testid="buildday-footer"
      className="relative bg-[#0A0A0C] border-t border-zinc-800 pt-24 pb-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          {/* Wordmark + cross-link to main programme */}
          <div className="md:col-span-6">
            <a
              href="/"
              data-testid="buildday-footer-back"
              className="inline-flex items-center gap-3 group mb-6"
            >
              <ArrowLeft className="w-4 h-4 text-zinc-500 group-hover:text-white transition-colors" />
              <span className="text-xs tracking-[0.3em] uppercase text-zinc-500 group-hover:text-white font-bold transition-colors">
                Back to The Builder Programme
              </span>
            </a>
            <div className="text-3xl md:text-5xl tracking-tighter font-extrabold text-white flex items-center gap-3">
              <span className="inline-block w-3 h-3 bg-[#FCD34D]" />
              BUILDERS<span className="text-zinc-500">·</span>SPRINT
            </div>
            <p className="mt-6 max-w-md text-sm md:text-base text-zinc-400 leading-relaxed">
              A one-day, in-person transformation experience by Jordan Young.
              Hosted at FMF Studio, London. For the longer mentorship, see{" "}
              <a
                href="/"
                data-testid="buildday-footer-mainprog-link"
                className="text-zinc-200 hover:text-white underline-offset-4 hover:underline"
              >
                The Builder Programme
              </a>
              .
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs tracking-[0.3em] uppercase text-zinc-500 font-bold mb-5">
              Navigate
            </h4>
            <ul className="space-y-3">
              {[
                { label: "About", href: "#about" },
                { label: "Schedule", href: "#schedule" },
                { label: "Outcomes", href: "#outcomes" },
                { label: "Apply", href: "#apply-buildday" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`buildday-footer-link-${l.label.toLowerCase()}`}
                    className="text-sm text-zinc-300 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="/"
                  data-testid="buildday-footer-link-builder-programme"
                  className="text-sm text-zinc-300 hover:text-white transition-colors"
                >
                  Builder Programme
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs tracking-[0.3em] uppercase text-zinc-500 font-bold mb-5">
              Connect
            </h4>
            <ul className="space-y-3">
              {SOCIAL.map((s) => {
                const Icon = s.icon;
                return (
                  <li key={s.label}>
                    <a
                      href={s.href}
                      target={s.id === "email" ? undefined : "_blank"}
                      rel="noopener noreferrer"
                      data-testid={`buildday-footer-social-${s.id}`}
                      className="inline-flex items-center gap-3 text-sm text-zinc-300 hover:text-white transition-colors"
                    >
                      <Icon className="w-4 h-4" strokeWidth={1.6} />
                      <span>{s.label}</span>
                    </a>
                  </li>
                );
              })}
              <li>
                <a
                  href={LINKS.stanStore}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="buildday-footer-social-stan-store"
                  className="inline-flex items-center gap-3 text-sm text-zinc-300 hover:text-white transition-colors"
                >
                  <ArrowUpRight className="w-4 h-4" strokeWidth={1.6} />
                  <span>Stan Store</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-zinc-900 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs tracking-[0.2em] uppercase text-zinc-600 font-bold">
            © {new Date().getFullYear()} Jordan Young · Find My Filmmaker
          </p>
          <p className="text-xs tracking-[0.2em] uppercase text-zinc-500 font-bold">
            The Builders Sprint · London
          </p>
        </div>
      </div>
    </footer>
  );
};
